import { jsx } from 'react/jsx-runtime';

const FormulaIcon = ({
  size,
  color = "currentColor"
}) => {
  return /*#__PURE__*/jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.946 15.267",
    style: {
      width: `${size.toString()}px`,
      height: `${size.toString()}px`
    },
    fill: color,
    children: /*#__PURE__*/jsx("path", {
      d: "M16.946 2.411H8.838l-1.9 12.636-2.225.218h.034L.004 6.716l1.68-.95 3.579 5.917L7.053-.005h9.9v2.41z"
    })
  });
};

export { FormulaIcon };
//# sourceMappingURL=FormulaIcon.js.map
